module.exports = __webpack_public_path__ + "img/24.9b1e39e9.png";